"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookiesClient = /** @class */ (function () {
    function CookiesClient($Cookies, $AcceptedCookies, showPolicyCookies) {
        var _this = this;
        if (showPolicyCookies === void 0) { showPolicyCookies = true; }
        this.Get = function (name) {
            return _this.$Cookies.Get(name);
        };
        this.Set = function (name, value, expiryHours) {
            if (_this.SHOW_POLICY_COOKIES && !_this.$CookiesConsent.IsAllowed(name)) {
                console.warn("[COOKIES_CONSENT] Cookie " + name + " not allowed");
                return;
            }
            _this.$Cookies.Set(name, value, expiryHours);
        };
        this.Delete = function (name) {
            _this.$Cookies.Delete(name);
        };
        this.$Cookies = $Cookies;
        this.$CookiesConsent = $AcceptedCookies;
        this.SHOW_POLICY_COOKIES = showPolicyCookies;
    }
    return CookiesClient;
}());
exports.default = CookiesClient;
//# sourceMappingURL=CookiesClient.js.map